export default {
	data() {
		return {
			dayStart: 0, //hrs from 00:00
			dayLength: 24,
			scheduleIncrement: 0.5, //hrs
			eventTotals: {
				numSickDaysUsed: false,
				numVacationUsed: false,
				numVacationScheduled: false,
				partialSickDayHrsUsed: false,
				numPartialSickDays: false
			},
			conflictResolutionModal: {
				visible: false,
				conflictEventId: null,
				message: null,
				newEventPayload: null,
				conflictEvent: null
			}
		}
	},
	computed: {
		resetDate() {
			let thisYear = this.moment().format("YYYY")

			let resetDate = this.moment().startOf("year")

			if (this.$store.company && "CompanySetting" in this.$store.company)
				resetDate = this.moment.utc(thisYear+"-"+this.$store.company.CompanySetting.vacation_reset_month+"-"+this.$store.company.CompanySetting.vacation_reset_day)

			if (resetDate.isAfter(this.moment.utc()))
				resetDate = resetDate.subtract(1,"y")

			return resetDate
		},
	},
	methods: {
		calcScheduleEventTypeTotals(events) {
			let vm = this

			let lessRejectedEvents = events.filter(event => event.rejected_by == 0).map(event => {
					event.durationHrs = vm.moment(event.end_time).diff(vm.moment(event.start_time),'hours')
					return event
				})

			let numSickDaysUsed = lessRejectedEvents
				.filter(event => {
					let durationHrs = this.moment(event.end_time).diff(this.moment(event.start_time),"hours")

					return event.is_sickday == 1 && (durationHrs == 0 || durationHrs > 8)
				})
				.reduce((acc,event) => {
					if (event.end_time) {
						let startTruncated = vm.moment(event.start_time).format("YYYY-MM-DD")
						let days = vm.moment(event.end_time).diff(vm.moment(startTruncated),'days')

						return acc+days
					}
					else
						return acc+1
				},0)



			let partialSickDayHrsUsed = lessRejectedEvents
				.filter(event => event.is_sickday == 1 && event.durationHrs > 0 && event.durationHrs < 8)
				.reduce((acc,event) => acc+ +event.durationHrs,0)
			
			let numPartialSickDays = lessRejectedEvents.filter(event => event.is_sickday == 1 && event.durationHrs > 0 && event.durationHrs < 8).reduce((acc,event) => acc + 1,0)

			let numVacationUsed = lessRejectedEvents.filter(event => this.moment(event.start_time).isBefore() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end_time) {
					let days = vm.moment(event.end_time).diff(vm.moment(event.start_time),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)
			
			let numVacationScheduled = lessRejectedEvents.filter(event => this.moment(event.start_time).isSameOrAfter() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end_time) {
					let days = vm.moment(event.end_time).diff(vm.moment(event.start_time),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)

			return {
				numSickDaysUsed,
				partialSickDayHrsUsed,
				numPartialSickDays,
				numVacationUsed,
				numVacationScheduled
			}
		},
		approveRejectVacation(event_id,approve) {
			let vm = this

			return new Promise((resolve,reject) => {

				//get event first
				vm.getJSON("ScheduleEvent/find/"+event_id,{},true).then(response => {
					if (response.success) {

						let payload = {
							user_id: response.data.user_id,
							id: event_id,
						}
						if (approve)
							payload.approved = 1
						else
							payload.approved = 0

						vm.postData("ScheduleEvent/vacation-approval",payload,true).then(postResponse => {
							if (postResponse.success) {
								if (approve)
									vm.alertSuccess("Vacation time approved")
								else
									vm.alertSuccess('Vacation time rejected. The user has been notified.')
							}
							resolve(postResponse)
						})
					}
					else
						resolve({
							success: false,
							error: "Event not found"
						})
				})
			})
		},
		deepCloneEventObj(obj) {
			if (obj) {
				if ("startMoment" in obj) {
					if (typeof obj.startMoment == 'object') 
						obj.startDateTimeString = obj.startMoment.format("YYYY-MM-DD HH:mm")
					else
						obj.startDateTimeString = obj.startMoment
					
					delete obj.startMoment
				}
				
				if ("endMoment" in obj) {
					if (typeof obj.endMoment == 'object') 
						obj.endDateTimeString = obj.endMoment.format("YYYY-MM-DD HH:mm")
					else
						obj.endDateTimeString = obj.endMoment
					
					delete obj.endMoment
				}
			
				let cloned = JSON.parse(JSON.stringify(obj))

				if ("startDateTimeString" in cloned) {
					cloned.startMoment = this.moment(cloned.startDateTimeString)
					delete cloned.startDateTimeString
				}
				
				if ("endDateTimeString" in cloned) {
					cloned.endMoment = this.moment(cloned.endDateTimeString)
					delete cloned.endDateTimeString
				}

				return cloned
			}
			else
				return obj
		},
		typeIcon(type) {
			if (type == "user")
				return "fa-user"
			if (type == "equipment" || type == 'equipment-servicing')
				return "fa-truck"
			if (type == "project")
				return "fa-cube"
			if (type == "service")
				return "fa-wrench"
		},
		calcIndexFromMoment(date,selectedDate) {
			let hour = this.dayStart
			if (hour < 10)
				hour = "0"+hour

			let hoursFromDayStart = this.moment(date).diff(this.moment(selectedDate+" "+hour+":00"),"minutes")/60

			return hoursFromDayStart / this.scheduleIncrement
		},
		renderEventObj(event) {
			//mutates an event into an object usable by the schedule

			let eventType, eventEntityKey, description, vm = this
			if (event.user_id > 0 && "User" in event) {
				eventType = 'user'
				eventEntityKey = "user_id"
				description = event.User.first_name+" "+event.User.last_name
			}
			else if (event.equipment_id > 0 && "Equipment" in event) {
				eventType = 'equipment'
				eventEntityKey = "equipment_id"

				if (!event.Equipment)
					description = "Equipment item (deleted)"
				else
					description = event.Equipment.description
			}
			else if (event.job_id > 0 && "Job" in event) {
				eventType = 'project'
				eventEntityKey = "job_id"
				description = event.Job.job_num+": "+event.Job.job_name
			}
			else if (event.service_id > 0 && "Service" in event) {
				eventType = 'service'
				eventEntityKey = "service_id"
				description = event.Service.job_num+": "+event.Service.job_name
			}

			let durationMins = vm.moment(event.end_time).diff(event.start_time,"minutes")

			let durationHrs = durationMins / 60

			let startMoment = vm.moment.utc(event.start_time).local()
			let endMoment = vm.moment.utc(event.end_time).local()

			let attachedJobDescription = ""
			if (eventType == 'user' || eventType == 'equipment') {
				if ("Service" in event && event.Service)
					attachedJobDescription = "Service #"+event.Service.job_num+": "+event.Service.job_name
				else if ("Job" in event && event.Job)
					attachedJobDescription = "Project #"+event.Job.job_num+": "+event.Job.job_name
			}

			let obj = {
				type: eventType,
				entityKey: eventEntityKey,
				id: event.id,
				startMoment,
				endMoment,
				duration: durationHrs,
				description,
				attachedJobDescription,
				shortDescription: vm.shortenDescription(description,durationHrs / vm.scheduleIncrement),
				isVacation: event.is_vacation,
				isSickday: event.is_sickday,
				is_published: event.is_published,
				is_off: event.is_off,
				userRole: false,
				notes: event.notes,
				starting_location: event.starting_location
			}

			let attached = ["Service","Job","User","ApprovedBy","RejectedBy","Equipment","user_id","equipment_id","service_id","job_id","repeat_until","is_vacation","is_sickday"]
			attached.forEach(key => {
				if (key in event)
					obj[key] = event[key]
			})

			//add a label for personnel role if this is a user event attached to a job and the user has a role on it
			if (eventType == 'user') {

				let jobkey = false
				if ("Job" in obj && obj.Job) 
					jobkey = "Job"
				else if ("Service" in obj && obj.Service)
					jobkey = "Service"
				
				if (jobkey && "JobPersonnelRole" in obj[jobkey] && obj[jobkey].JobPersonnelRole) 
					//check if user is assigned to one of these roles
					obj.userRole = obj[jobkey].JobPersonnelRole.find(role => role.user_id == obj.User.id)	
				
			}

			return obj
		},
		renderEquipmentObj(eq) {
			let vm = this
			let startMoment = vm.moment(eq.next_service_date+" 00:00")

			let duration = 24

			let description = "Servicing: "+eq.description+": "+eq.next_service_description
			
			let obj = {
				type: 'equipment-servicing',
				id: eq.id,
				equipmentSlug: eq.slug,
				startMoment,
				endMoment: vm.moment(eq.next_service_date).endOf("day"),
				duration,
				startIndex: vm.calcIndexFromMoment(startMoment,this.selectedDate),
				description,
				shortDescription: vm.shortenDescription(description,duration / vm.scheduleIncrement)
			}

			return obj
		},
		sortEventRowsToEntityTypes(rows) {
			//sort into entity types first
			let users = rows.filter(row => row.type == 'user')
			let equipment = rows.filter(row => row.type == 'equipment')
			let projects = rows.filter(row => row.type == 'project')
			let services = rows.filter(row => row.type == 'service')
			let eqServicing = rows.filter(row => row.type == 'equipment-servicing')

			let sorted = []
			projects.sort((a,b) => {
				if (a.items[0].Job.job_num > b.items[0].Job.job_num)
					return 1
				return -1
			})
			services.sort((a,b) => {
				if (a.items[0].Service.job_num > b.items[0].Service.job_num)
					return 1
				return -1
			})
			users.sort((a,b) => {
				if (a.description.toUpperCase() > b.description.toUpperCase())
					return 1
				return -1
			})
			equipment.sort((a,b) => {
				if (a.description > b.description)
					return 1
				return - 1
			})

			return {
				projects,
				services,
				users,
				equipment,
				eqServicing
			}
		},
		renderScheduleRows(events,equipmentServicing) {
			let rows = [], vm = this

			if (events) {
				events.forEach(event => {
					let obj = vm.renderEventObj(event)

					obj.startIndex = vm.calcIndexFromMoment(obj.startMoment,this.selectedDate)

					let color_hex = ""
					if (obj.type == 'user' && obj.User && obj.User.EmployeeSetting && obj.User.EmployeeSetting.length > 0)
						color_hex = obj.User.EmployeeSetting[0].color_hex 


					//find matching row
					let matchIndex = rows.findIndex(row => row.type == obj.type && row.entity_id == event[obj.entityKey])

					if (matchIndex >= 0) {
						//add to items
						rows[matchIndex].items.push(obj)
					}
					else {
						rows.push({
							type: obj.type,
							entity_id: event[obj.entityKey],
							entityKey: obj.entityKey,
							items: [obj],
							description: obj.description,
							color_hex
						})
					}
				})
			}

			if (equipmentServicing) {
				equipmentServicing.forEach(eq => {

					let obj = vm.renderEquipmentObj(eq)

					rows.push({
						type: "equipment-servicing",
						entity_id: eq.id,
						entityKey: "equipment_id",
						description: obj.description,
						items: [obj]
					})
				})
			}

			/*
				Should be sorted by:
				Project
					Users
					Equipment
				Service
					Users
					Equipment
				User Events
				Equipment Events
			*/
			//sort into entity types first
			let sorted = []
			let {projects,services,users,equipment,eqServicing} = this.sortEventRowsToEntityTypes(rows)

			projects.forEach(projectEvent => {
				sorted.push(projectEvent)

				//find all users attached to this project
				users
					.filter(userRow => {
						//has this job on them
						return userRow.items.find(item => "job_id" in item && item.job_id == projectEvent.entity_id)
					})
					.map(userRow => {
						userRow.isProjectRelatedRow = true

						userRow.items = userRow.items.map(item => vm.deepCloneEventObj(item))

						return userRow
					})
					.forEach(userRow => {

						let clonedRow = JSON.parse(JSON.stringify(userRow)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent =>  eqEvent.items.find(item => "job_id" in item && item.job_id == projectEvent.entity_id))
					.map(eqEvent => {
						eqEvent.isProjectRelatedRow = true

						eqEvent.items = eqEvent.items.map(item => vm.deepCloneEventObj(item))

						return eqEvent
					})
					.forEach(eqEvent => {

						let clonedRow = JSON.parse(JSON.stringify(eqEvent)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})
			})

			//next come the services with all their stuff
			services.forEach(serviceEvent => {
				sorted.push(serviceEvent)

				//find all users attached to this project
				users
					.filter(userRow => userRow.items.find(item => "service_id" in item && item.service_id == serviceEvent.entity_id))
					.map(userRow => {
						userRow.isServiceRelatedRow = true

						userRow.items = userRow.items.map(item => vm.deepCloneEventObj(item))

						return userRow
					})
					.forEach(userRow => {

						let clonedRow = JSON.parse(JSON.stringify(userRow)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent => eqEvent.items.find(item => "service_id" in item && item.service_id == serviceEvent.entity_id))
					.map(eqEvent => {
						eqEvent.isServiceRelatedRow = true

						eqEvent.items = eqEvent.items.map(item => vm.deepCloneEventObj(item))

						return eqEvent
					})
					.forEach(eqEvent => {

						let clonedRow = JSON.parse(JSON.stringify(eqEvent)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})
			})

			//next is the equipment servicings
			sorted = [
				...sorted,
				...eqServicing
			]

			//all the standalone user events
			sorted = [
				...sorted,
				...users.filter(userRow => {
					//show user here if user has any events that aren't attached to jobs
					return userRow.items.find(item => item.job_id == 0 && item.service_id == 0)
				})
				.map(userRow => {
					userRow.isStandalone = true
					return userRow
				})
			]

			//all the standalone equipment events
			sorted = [
				...sorted,
				...equipment.filter(eqRow => {
					//show equipment event here if eq has any events that aren't attached to jobs
					return eqRow.items.find(item => item.job_id == 0 && item.service_id == 0)
				})
				.map(eqRow => {
					eqRow.isStandalone = true
					return eqRow
				})
			]

			//now go through the entire list again, and flag the events that aren't related to the jobs they are listed underneath
			let theJobId, theJobKey
			sorted = sorted.map(row => {

				if (row.type == 'project' || row.type == 'service') {
					theJobId = row.entity_id
					theJobKey = row.entityKey
				}
				else {
					if ("isProjectRelatedRow" in row && !row.isProjectRelatedRow && "isServiceRelatedRow" in row && !row.isServiceRelatedRow) 
						theJobId = null

					/*
					if ((!("isServiceRelatedRow" in row) || !row.isServiceRelatedRow) && (!("isProjectRelatedRow" in row) || !row.isProjectRelatedRow)) {
						theJobId = null
						theJobKey = null
					}
					*/

					row.items = row.items.map(item => {

						if ((!("isStandalone" in row) || !row.isStandalone) && item[theJobKey] != theJobId) {

							if ("isServiceRelatedRow" in row && row.isServiceRelatedRow && vm.filters.mainTypes.indexOf("service") >= 0)
								item.itemUnrelatedToParent = true
							else if ("isProjectRelatedRow" in row && row.isProjectRelatedRow && vm.filters.mainTypes.indexOf("project") >= 0)
								item.itemUnrelatedToParent = true
							else 
								item.itemUnrelatedToParent = false
						}
						else if ("isStandalone" in row && row.isStandalone) {
							if (item.service_id > 0 || item.job_id > 0)
								item.itemUnrelatedToParent = true
							else
								item.itemUnrelatedToParent = false
						}
						else
							item.itemUnrelatedToParent = false

						return item
					})
				}

				return row
			})

			return sorted
		},
		filterRenderedScheduleRows(rows) {
			let vm = this

			if (!rows)
				return []

			let projectsUserIsOn = [], servicesUserIsOn = []

			if (vm.filters.mineOnly) {
				rows
					.filter(row => 
						row.type == "user" && 
						row.entity_id == vm.$store.userDetails.id && 
						row.isProjectRelatedRow)
					.forEach(row =>  {
						row.items.forEach(item => {
							if (item.job_id > 0)
								projectsUserIsOn.push(item.job_id)
						})
					})

				rows
					.filter(row => 
						row.type == "user" && 
						row.entity_id == vm.$store.userDetails.id && 
						row.isServiceRelatedRow)
					.forEach(row =>  {
						row.items.forEach(item => {
							if (item.service_id > 0)
								servicesUserIsOn.push(item.service_id)
						})
					})
			}

			let filtered = rows.filter(row => {

				if (vm.filters.mainTypes.indexOf(row.type) == -1)
					return false

				let include = true

				if (row.type == 'project' && vm.projectFiltering && vm.filters.projectIds.length > 0)
					include = vm.filters.projectIds.find(id => id == row.entity_id)

				if (row.type == 'service' && vm.serviceFiltering && vm.filters.serviceIds.length > 0) 
					include = vm.filters.serviceIds.find(id => id == row.entity_id)

				if (row.type == 'user' && vm.userFiltering && vm.filters.userIds.length > 0)  
					include = vm.filters.userIds.find(id => id == row.entity_id)

				if (vm.filters.mineOnly && include) {

					if (row.type == 'equipment-servicing')
						return false
					else if (row.type == 'user' && row.entity_id == vm.$store.userDetails.id)
						return true

					//if row is a project, check $store.userProjectIds (jobs user has role on)
					if (row.type == 'project')
						include = vm.$store.userProjectIds.find(jobId => row.entity_id == jobId)
					else if (row.type == 'service')
						include = vm.$store.userServiceIds.find(jobId => row.entity_id == jobId)
					else if (row.isProjectRelatedRow || row.isServiceRelatedRow) {
						let hasRelatedJobItems = row.items.find(item => vm.$store.userProjectIds.indexOf(item.job_id) >= 0 || vm.$store.userServiceIds.indexOf(item.service_id) >= 0)

						if (!hasRelatedJobItems)
							include = false
					}

					//check jobs user is scheduled on
					if (row.type == 'project')
						include = projectsUserIsOn.find(jobId => row.entity_id == jobId)
					else if (row.type == 'service')
						include = servicesUserIsOn.find(jobId => row.entity_id == jobId)
					else if (row.isProjectRelatedRow || row.isServiceRelatedRow) {
						let hasRelatedJobItems = row.items.find(item => projectsUserIsOn.indexOf(item.job_id) >= 0 || servicesUserIsOn.indexOf(item.service_id) >= 0)

						if (!hasRelatedJobItems)
							include = false
					}
				}

				if (vm.filters.showOnlyRelated) {
					if (vm.serviceFiltering && (row.type == 'user' || row.type == 'equipment')) {
						//only include if this event is related to events in the services list
						include = row.items.find(item => vm.filters.serviceIds.indexOf(item.service_id) >= 0)
					}

					if (vm.projectFiltering & (row.type == 'user' || row.type == 'equipment')) {
						//only incldue if the this event is related to the events in the projects list
						include = row.items.find(item => vm.filters.projectIds.indexOf(item.job_id) >= 0)

					}
				}

				return include
			})

			if (vm.filters.mainTypes.indexOf('service') == -1) {
				//service events are turned off, collapse any user/equipment service events that are duplicated
				let userIdsShowing = []
				filtered = filtered.filter(row => {
					if (row.type == 'user' && "isServiceRelatedRow" in row && row.isServiceRelatedRow && userIdsShowing.indexOf(row.entity_id) !== -1)
						return false
					else {
						userIdsShowing.push(row.entity_id)
						return true
					}
				})

			}
			if (vm.filters.mainTypes.indexOf("project") == -1) {
				//project events are turned off, collapse any user/equipment project events that are duplicated
				let userIdsShowing = []
				filtered = filtered.filter(row => {
					if (row.type == 'user' && "isProjectRelatedRow" in row && row.isProjectRelatedRow && userIdsShowing.indexOf(row.entity_id) !== -1)
						return false
					else {
						userIdsShowing.push(row.entity_id)
						return true
					}
				})
			}

			return filtered
		},
		shortenDescription(description,duration) {
			let maxLength = duration * 16
			if (description && description.length > maxLength)
				return description.substring(0,maxLength)+"&#8230;"

			return description
		},
		saveEvent(payload) {
			let vm = this

			vm.conflictResolutionModal.message = ""
			vm.conflictResolutionModal.newEventPayload = null
			vm.conflictResolutionModal.conflictEvent = null

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.postData("ScheduleEvent/save",payload,true).then(response => {
					vm.spinner(false)

					if (response.success)
						vm.alertSaved("Event saved")
					else if ("errorType" in response && response.errorType == 'conflict') {
						vm.conflictResolutionModal.visible = true
						vm.conflictResolutionModal.message = response.errors[0]
						vm.conflictResolutionModal.newEventPayload = payload
						vm.conflictResolutionModal.conflictEvent = response.conflictEvent
					}
					else
						vm.alertErrors(response.errors)

					resolve(response)
				})
			})
		},
	}
}